import React, { useState, useMemo } from "react";
//import Section from "components/sections/sections";
import PaginationButton from "../button/paginationButton";
import Container from "components/sections/container";
import usePagination from "hooks/usePagination";
import { filterGallery } from "utils/utils";
import ImageGallery from "../imageGallery.";
import ImageModal from "components/portal/imageModal";
import { getGallery } from "utils/api/gallery";

const GalleryResultComponent = ({ results, meta }, ref) => {
  const limit = 6;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const [currentPage, resultData, setCurrentPage] = usePagination(
    1,
    (start, pageSize, filters) => getGallery(start, pageSize, filters),
    limit,
    results,
    filterGallery(ref)
  );
  const createPaginationButtons = () => {
    const pagination = meta?.pagination;
    if (pagination?.pageCount === 1) {
      return [];
    }
    return (
      meta?.pagination &&
      [...Array(pagination.pageCount)].map((_, index) => {
        const PAGE = index + 1;
        return (
          <PaginationButton
            onClick={() => {
              setCurrentPage(PAGE);
            }}
            active={PAGE === currentPage}
            value={PAGE}
            key={"pagination-button-" + PAGE}
          />
        );
      })
    );
  };
  const MemorizedButtons = useMemo(createPaginationButtons, [
    currentPage,
    meta?.pagination,
    setCurrentPage,
  ]);
  const selectedImage = resultData && resultData?.[currentImage]?.attributes;
  return (
    <>
      {isModalOpen && (
        <ImageModal
          image={selectedImage.image?.data?.attributes?.url}
          isDownloadable={selectedImage.downloadable}
          toggleModal={() => setIsModalOpen((prev) => !prev)}
        />
      )}
      <Container>
        <div className="body my-8">
          {resultData && resultData?.length ? (
            <ImageGallery
              images={resultData.map((data) => {
                const gallery = data?.attributes;
                return gallery?.image?.data?.attributes?.url;
              })}
              onClick={setCurrentImage}
              openModal={setIsModalOpen}
            />
          ) : (
            <h1 className="flex justify-start text-2xl font-bold my-2">
              No Result Found
            </h1>
          )}
          <div className="flex items-center justify-center gap-2 my-8">
            {MemorizedButtons}
            {meta?.pagination?.pageCount > 1 && (
              <PaginationButton
                value={"Next"}
                onClick={() => {
                  if (currentPage < meta?.pagination?.pageCount)
                    setCurrentPage((state) => state + 1);
                }}
              />
            )}
          </div>
        </div>
      </Container>
    </>
  );
};

export default React.memo(React.forwardRef(GalleryResultComponent));
